import Script from "next/script"

const EcomailTracking = () => {
  return (
    <>
      <Script
        id="ecomail-tracker"
        strategy="afterInteractive" // Nebo 'lazyOnload' podle tvých potřeb
        dangerouslySetInnerHTML={{
          __html: `
            ;(function(p,l,o,w,i,n,g){if(!p[i]){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[];
            p.GlobalSnowplowNamespace.push(i);p[i]=function(){(p[i].q=p[i].q||[]).push(arguments)
            };p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1;
            n.src=w;g.parentNode.insertBefore(n,g)}}(window,document,"script","//d70shl7vidtft.cloudfront.net/ecmtr-2.4.2.js","ecotrack"));
            window.ecotrack('newTracker', 'cf', 'd2dpiwfhf3tz0r.cloudfront.net', { /* Initialise a tracker */
            appId: 'vzdelanibudoucnosti', consentModeV2: true
            });
            window.ecotrack('setUserIdFromLocation', 'ecmid');
            window.ecotrack('trackPageView');
          `
        }}
      />
      {/* Zbytek tvé komponenty */}
    </>
  )
}

export default EcomailTracking
